import axios from 'axios'

const token = localStorage.getItem('token');

axios.defaults.baseURL = process.env.VUE_APP_APIURL
axios.defaults.headers.common['Content-Type'] = 'application/json';

if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            const originalConfig = err.config;
            if (originalConfig.url !== "/login" && err.response) {
                if (err.response.status === 401 && !originalConfig._retry) {
                    originalConfig._retry = true;
                    try {
                        localStorage.clear();
                        window.location.href = "/login"
                    } catch (_error) {
                        return Promise.reject(_error);
                    }
                }
            }
            return Promise.reject(err);
        }
    );
}

export default axios;